// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"980px","desktopWidth":"1920px","popoverList":"mainMenu_popoverList__36m6T","menu":"mainMenu_menu__tr8cm","btn":"mainMenu_btn__3MvXy"};